import { render } from "./FrameBuilderFE.vue?vue&type=template&id=64207d96&scoped=true"
import script from "./FrameBuilderFE.vue?vue&type=script&lang=js"
export * from "./FrameBuilderFE.vue?vue&type=script&lang=js"

import "./FrameBuilderFE.vue?vue&type=style&index=0&id=64207d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64207d96"]])

export default __exports__